import React, { useState } from 'react'

import { PlusOutlined, QuestionCircleFilled } from '@ant-design/icons'
import FlexibleProductConceptModal from '@shared/flexible_products/FlexibleProductConceptModal'
import FlexibleProductsListView from '@components/shared/flexible_products/FlexibleProductsListView'
import Can from '@shared/permissions/Can'
import ListPageHeader from '@shared/ListPageHeader'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { flexibleProductService } from '@services/operator/flexibleProductService'

const OperatorFlexibleProductsList: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [conceptModalVisible, setConceptModalVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        items={['products', 'products.flexible_products']}
        guideButton={
          <Tooltip title={t('concepts.flexible_products.tooltip')}>
            <Button
              type="text"
              size="small"
              icon={<QuestionCircleFilled style={{ color: '#1890ff' }} />}
              onClick={() => setConceptModalVisible(true)}
              style={{ padding: 0, height: 'auto', minWidth: 'auto' }}
            />
          </Tooltip>
        }
        actions={
          <Can requiredPermission="products:write">
            <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/flexible_products/new')}>
              {t('common.button.new')}
            </Button>
          </Can>
        }
      />
      <FlexibleProductsListView
        role="operator"
        service={flexibleProductService}
      />
      <FlexibleProductConceptModal
        visible={conceptModalVisible}
        onClose={() => setConceptModalVisible(false)}
      />
    </div>
  )
}

export default OperatorFlexibleProductsList;
